// tslint:disable
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url'
import { Configuration } from './configuration'
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base'

/**
 *
 * @export
 * @interface Binding
 */
export interface Binding {
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bindingId?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bindingType?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  balance?: number
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bankId?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bic?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  bankName?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  image?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  maskedPan?: string
  /**
   *
   * @type {string}
   * @memberof Binding
   */
  cardType?: string
}
/**
 *
 * @export
 * @interface BindingRs
 */
export interface BindingRs {
  /**
   *
   * @type {string}
   * @memberof BindingRs
   */
  userId?: string
  /**
   *
   * @type {Array<Binding>}
   * @memberof BindingRs
   */
  bindings?: Array<Binding>
  /**
   *
   * @type {ErrorRs}
   * @memberof BindingRs
   */
  error?: ErrorRs
}
/**
 *
 * @export
 * @interface ErrorRs
 */
export interface ErrorRs {
  /**
   *
   * @type {number}
   * @memberof ErrorRs
   */
  code?: number
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  uuid?: string
  /**
   *
   * @type {string}
   * @memberof ErrorRs
   */
  details?: string
}

/**
 * ControllerApi - axios parameter creator
 * @export
 */
export const ControllerApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindingsSdk(options: any = {}): RequestArgs {
      const localVarPath = `/b/plat-sdk-gateway/getBindings.do`
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = { ...localVarUrlObj.query, ...localVarQueryParameter, ...options.query }
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers }

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ControllerApi - functional programming interface
 * @export
 */
export const ControllerApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindingsSdk(options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BindingRs> {
      const localVarAxiosArgs = ControllerApiAxiosParamCreator(configuration).getBindingsSdk(options)
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = { ...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url }
        return axios.request(axiosRequestArgs)
      }
    },
  }
}

/**
 * ControllerApi - factory interface
 * @export
 */
export const ControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBindingsSdk(options?: any): AxiosPromise<BindingRs> {
      return ControllerApiFp(configuration).getBindingsSdk(options)(axios, basePath)
    },
  }
}

/**
 * ControllerApi - object-oriented interface
 * @export
 * @class ControllerApi
 * @extends {BaseAPI}
 */
export class ControllerApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ControllerApi
   */
  public getBindingsSdk(options?: any) {
    return ControllerApiFp(this.configuration).getBindingsSdk(options)(this.axios, this.basePath)
  }
}
